import { render } from "./Footer.vue?vue&type=template&id=027d006c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=027d006c&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=027d006c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027d006c"]])

export default __exports__